import React, { useEffect } from "react";
import { useVeltClient } from "../context";
export function useTagUtils() {
    var _a = React.useState(), tagElement = _a[0], setTagElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || tagElement)
            return;
        var loadedTagElement = client.getTagElement();
        setTagElement(loadedTagElement);
    }, [client, setTagElement, tagElement]);
    return tagElement;
}
export function useTagAnnotations(documentId, location) {
    var tagElement = useTagUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!tagElement)
            return;
        var subscription = tagElement.getAllTagAnnotations(documentId, location).subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [tagElement]);
    return data;
}
